define('konnekt/outsystems/frame-tools',[
	"util/resize-observer",
	"util/channel"
], function( ResizeObserver, Channel ) {

	"use strict";

	var
		channel  = new Channel({ remote : window.parent, name : "konnekt-frame" }).open(),
		observer = new ResizeObserver( function( entries ) {
			channel.dispatch( "resize", {
				clientHeight : entries[ 0 ].clientHeight,
				clientWidth  : entries[ 0 ].clientWidth
			});
		});

	function extractElement( obj ) {
		if ( typeof obj === "string" ) {
			obj = document.querySelectorAll( obj );
			if ( obj.length !== 0 ) { return obj[ 0 ]; }
		}

		// If the object has a "length" property and is *not* a DOM element, assume
		// we're dealing with an array-like node set and take the first node from
		// it.
		// We explicitly need to check for the object not being a DOM element, because
		// some element types such as HTMLSelectElement have a length property as well.
		if (( obj != null ) && !( obj instanceof Element ) && ( "number" === typeof obj.length )) {
			obj = obj[ 0 ];
		}

		return obj instanceof Element ? obj : null;
	}

	function resizeOnElement( element ) {
		element = extractElement( element );
		if ( element == null ) {
			throw new TypeError( "element was not a valid DOM element, selector or jQuery node list." );
		}

		observer.disconnect();
		observer.observe( element );
	};

	function scrollToElement( element, axis ) {
		element = extractElement( element );
		if ( element == null ) {
			throw new TypeError( "element was not a valid DOM element, selector or jQuery node list." );
		}

		if ( element.ownerDocument !== document ) { 
			throw new Error( "element does not belong to the frame document and is not supported." )
		}

		if ( axis == null ) axis = "y";
		if ( typeof axis !== "string" ) {
			throw new Error( "Bad axis specification" );
		}

		if ( element.getClientRects().length ) {
			var rect = element.getBoundingClientRect();
			channel.dispatch( "scroll", {
				x : /x/.test(axis) ? rect.left : undefined,
				y : /y/.test(axis) ? rect.top  : undefined
			});
		}
	}

	function scrollToPosition( x, y ) {
		channel.dispatch( "scroll", {
			x : isNaN( x ) ? undefined : Number( x ),
			y : isNaN( y ) ? undefined : Number( y )
		});
	}

	return {
		resizeOn : resizeOnElement,
		scrollTo : function( obj ) {
			if ( obj == null ) throw new TypeError( "argument was null" );

			if ( !isNaN( obj.x ) || !isNaN( obj.y )) {
				scrollToPosition( obj.x, obj.y );
			} else {
				scrollToElement( obj );
			}
		},

		ready    : function() { channel.dispatch( "ready" ) },

		callback : function( name /*, ... */ ) {
			var
				n = arguments.length - 1,
				args;

			if ( n > 0 ) {
				args = new Array( n );
				while ( --n !== -1 ) {
					args[ n ] = arguments[ n + 1 ];
				}

				channel.dispatch( "callback", {
					name : name,
					args : args
				});
			}
		}
	}
});
